import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatchService } from '../match.service';
import swal from "sweetalert2";
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { UserService } from '../user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home2',
  templateUrl: './home2.component.html',
  styleUrls: ['./home2.component.css']
})
export class Home2Component implements OnInit, OnDestroy {
  isLoading = false;
  isScore = false;
  match: any[];
  scoreList1: any;
  scoreList2: any;
  scoreList3: any;
  scoreList4: any;
  level = '0';
  eventId: any;
  eventName: any;
  matchSubs: Subscription;
  constructor(private matchService: MatchService, private http: HttpClient,
    private userService: UserService, private router: Router) { }

  ngOnInit() {
    this.isLoading = true;
    this.level = this.userService.getUserLevel();
    // if (this.level == '2') {
    //   this.router.navigateByUrl('/home');
    // }
    // else {
    this.matchService.getScoreList().subscribe((response) => {
      //console.log(response);
      this.scoreList1 = response[0]['result'];
      this.scoreList2 = response[1]['result'];
      this.scoreList3 = response[2]['result'];
      this.scoreList4 = response[3]['result'];
      this.isScore = true;
      //this.scoreList2 = response[1];
    });

    // this.matchService.getScoreList2().subscribe((response) => {
    //   console.log(response);
    //   // this.scoreList1 = response[0];
    //   // this.isScore = true;
    //   //this.scoreList2 = response[1];
    // });

    //this.getScoreList();

    //this.matchService.getActiveMatch();    
    this.matchService.getMatches(true, false, "own", 4);
    this.matchSubs = this.matchService.getUpdateMatchListner()
      .subscribe((response) => {
        //console.log(response);
        this.match = response.match;
        this.isLoading = false;
      },
        error => {
          console.log(error);
          this.isLoading = false;
        });
    //}
  }

  updateScore(inc, eventId) {
    var btn = document.getElementById('btn' + inc);
    var process = document.getElementById('process' + inc);
    var scoreData = document.getElementById('score' + inc) as HTMLSelectElement;

    var span = document.getElementById('error' + inc);
    //console.log();
    btn.style.display = 'none';
    process.style.display = 'block';

    if (!scoreData.value) {
      //console.log('Error');
      span.style.display = 'block';
      btn.style.display = 'block';
      process.style.display = 'none';
    }
    else {
      span.style.display = 'none';
      let data = JSON.parse(this.remove_linebreaks(scoreData.value));
      var name = data.liveline;
      let type;
      if (name.startsWith("Exch")) {
        type = 'CR';
      }
      else if (name.startsWith("LiveLine")) {
        type = 'liveline';
      }
      else if (name.startsWith("CricBuzz")) {
        type = 'CB';
      }
      else if (name.startsWith("Bsf")) {
        type = 'UP';
      }
      //console.log(data);
      let data1 = { "id": data.cricexchageid, "eventId": eventId, "type": type };
      let data2 = { ...data, "marketid": eventId };
      //console.log(data1);
      //console.log(data2);
      this.matchService.updateMatchScore(data1, data2).subscribe((response) => {
        //console.log(response);
        btn.style.display = 'block';
        process.style.display = 'none';
        this.msgSuccess();
      },
        error => {
          //console.log(error);
          this.msgFailure();
          btn.style.display = 'block';
          process.style.display = 'none';
        });
    }
  }

  updateOdds(inc, eventId) {
    var btn = document.getElementById('obtn' + inc);
    var process = document.getElementById('oprocess' + inc);
    var odds = document.getElementById('odds' + inc) as HTMLSelectElement;
    var span = document.getElementById('oerror' + inc);

    btn.style.display = 'none';
    process.style.display = 'block';

    if (!odds.value) {
      span.style.display = 'block';
      btn.style.display = 'block';
      process.style.display = 'none';
    }
    else {
      span.style.display = 'none';
      let data = { "oddsProvider": odds.value, "eventId": eventId };
      this.matchService.updateMatchOdds(data).subscribe((response) => {
        //console.log(response);
        btn.style.display = 'block';
        process.style.display = 'none';
        this.msgSuccess();
      },
        error => {
          //console.log(error);
          btn.style.display = 'block';
          process.style.display = 'none';
          this.msgFailure();
        });
    }
  }

  updateFancy(inc, eventId) {
    var btn = document.getElementById('fbtn' + inc);
    var process = document.getElementById('fprocess' + inc);
    var fancy = document.getElementById('fancy' + inc) as HTMLSelectElement;
    var span = document.getElementById('ferror' + inc);

    btn.style.display = 'none';
    process.style.display = 'block';

    if (!fancy.value) {
      span.style.display = 'block';
      btn.style.display = 'block';
      process.style.display = 'none';
    }
    else {
      span.style.display = 'none';
      let data = { "fancyProvider": fancy.value, "eventId": eventId };
      this.matchService.updateMatchFancy(data).subscribe((response) => {
        //console.log(response);
        btn.style.display = 'block';
        process.style.display = 'none';
        this.msgSuccess();
      },
        error => {
          //console.log(error);
          btn.style.display = 'block';
          process.style.display = 'none';
          this.msgFailure();
        });
    }
  }

  updateBM(inc, eventId) {
    var btn = document.getElementById('bmbtn' + inc);
    var process = document.getElementById('bmprocess' + inc);
    var bm = document.getElementById('bm' + inc) as HTMLSelectElement;
    var span = document.getElementById('bmerror' + inc);

    btn.style.display = 'none';
    process.style.display = 'block';

    if (!bm.value) {
      span.style.display = 'block';
      btn.style.display = 'block';
      process.style.display = 'none';
    }
    else {
      span.style.display = 'none';
      let data = { "bmProvider": bm.value, "eventId": eventId };
      this.matchService.updateBookMaker(data).subscribe((response) => {
        //console.log(response);
        btn.style.display = 'block';
        process.style.display = 'none';
        this.msgSuccess();
      },
        error => {
          //console.log(error);
          btn.style.display = 'block';
          process.style.display = 'none';
          this.msgFailure();
        });
    }
  }

  updateAFancy(inc, eventId) {
    var btn = document.getElementById('afbtn' + inc);
    var process = document.getElementById('afprocess' + inc);
    var afancy = document.getElementById('afancy' + inc) as HTMLSelectElement;
    btn.style.display = 'none';
    process.style.display = 'block';
    let data = { "fancyAType": afancy.value, "eventId": eventId };
    this.matchService.updateMatchFancyAType(data).subscribe((response) => {
      //console.log(response);
      btn.style.display = 'block';
      process.style.display = 'none';
      this.msgSuccess();
    },
      error => {
        //console.log(error);
        btn.style.display = 'block';
        process.style.display = 'none';
        this.msgFailure();
      });
  }

  updateAddType(inc, eventId) {
    var btn = document.getElementById('atbtn' + inc);
    var process = document.getElementById('atprocess' + inc);
    var addtype = document.getElementById('addtype' + inc) as HTMLSelectElement;
    btn.style.display = 'none';
    process.style.display = 'block';
    let data = { "addType": addtype.value, "eventId": eventId };
    this.matchService.updateMatchAddType(data).subscribe((response) => {
      //console.log(response);
      btn.style.display = 'block';
      process.style.display = 'none';
      this.msgSuccess();
    },
      error => {
        //console.log(error);
        btn.style.display = 'block';
        process.style.display = 'none';
        this.msgFailure();
      });
  }

  setResult(inc, eventId, eventName) {
    var btn = document.getElementById('rbtn' + inc);
    var process = document.getElementById('rprocess' + inc);
    var result = document.getElementById('result' + inc) as HTMLSelectElement;
    var span = document.getElementById('rerror' + inc);

    btn.style.display = 'none';
    process.style.display = 'block';

    if (!result.value) {
      span.style.display = 'block';
      btn.style.display = 'block';
      process.style.display = 'none';
    }
    else {
      //console.log(result.value);
      let json = JSON.parse(result.value);
      let data = {
        "marketid": eventId, "marketname": "Match Odds", "sportid": 4,
        "sportname": "Cricket", "matchid": parseInt(eventId), "matchname": eventName,
        "selectionid": json.id, "selectionname": json.name, "result": parseInt(json.id),
        "markettype": "Odds"
      };
      span.style.display = 'none';
      this.matchService.setMatchResult(data)
        .subscribe((response) => {
          this.msgSuccess();
          //console.log(response);
          this.matchService.getMatches(true, false, "own", 4);
          btn.style.display = 'block';
          process.style.display = 'none';
        },
          error => {
            //console.log(error);
            btn.style.display = 'block';
            process.style.display = 'none';
            this.msgFailure();
          });
    }
  }

  removeMatch(inc, eventId) {
    //var btn = document.getElementById('mbtn' + inc);
    //var process = document.getElementById('mprocess' + inc);
    //btn.style.display = 'none';
    //process.style.display = 'block';
    this.isLoading = true;
    this.matchService.setResultStatus(eventId).subscribe((response) => {
      //console.log(response);
      this.msgSuccess();
      this.matchService.getMatches(true, false, "own", 4);
      //btn.style.display = 'block';
      //process.style.display = 'none';
    },
      error => {
        //console.log(error);
        //btn.style.display = 'block';
        //process.style.display = 'none';
        this.isLoading = false;
        this.msgFailure();
      });
  }

  deleteMatch(inc, eventId) {
    //var btn = document.getElementById('mbtn' + inc);
    //var process = document.getElementById('mprocess' + inc);
    //btn.style.display = 'none';
    //process.style.display = 'block';
    this.isLoading = true;
    this.matchService.deleteMatch(eventId).subscribe((response) => {
      //console.log(response);
      this.msgSuccess();
      this.matchService.getMatches(true, false, "own", 4);
      //btn.style.display = 'block';
      //process.style.display = 'none';
    },
      error => {
        //console.log(error);
        //btn.style.display = 'block';
        //process.style.display = 'none';
        this.isLoading = false;
        this.msgFailure();
      });
  }

  setData(eventId, eventName) {
    this.eventId = eventId;
    this.eventName = eventName;
  }

  removeData() {
    this.eventId = '';
    this.eventName = '';
  }

  updateHeader() {
    return;
    let btn = document.getElementById('hbtn');
    let process = document.getElementById('hprocess');
    let header = (<HTMLInputElement>document.getElementById('hname')).value;
    let team1 = (<HTMLInputElement>document.getElementById('team1')).value;
    let team2 = (<HTMLInputElement>document.getElementById('team2')).value;
    let team3 = (<HTMLInputElement>document.getElementById('team3')).value;
    btn.style.display = 'none';
    process.style.display = 'block';
    const data = { eventid: this.eventId, header, team1, team2, team3 };
    this.matchService.updateHeader(data).subscribe((response) => {
      //console.log(response);
      (<HTMLInputElement>document.getElementById('hname')).value = '';
      (<HTMLInputElement>document.getElementById('team1')).value = '';
      (<HTMLInputElement>document.getElementById('team2')).value = '';
      (<HTMLInputElement>document.getElementById('team3')).value = '';
      this.msgSuccess();
      btn.style.display = 'block';
      process.style.display = 'none';
    },
      error => {
        //console.log(error);
        btn.style.display = 'block';
        process.style.display = 'none';
        this.msgFailure();
      });
  }

  msgSuccess() {
    swal.fire({
      icon: 'success',
      title: 'Successfully Update!',
      showConfirmButton: false,
      timer: 1500
    })
  }

  msgFailure() {
    swal.fire({
      icon: 'error',
      title: 'Something Went Wrong!',
      showConfirmButton: false,
      timer: 1500
    })
  }

  remove_linebreaks(str) {
    return str.replace(/[\r\n]+/gm, "");
  }

  ngOnDestroy() {
    if (this.matchSubs) {
      this.matchSubs.unsubscribe();
    }
  }
}